import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { Connection1cFindInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-find.dto';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  standalone: true,
  selector: 'crm-database-single-select',
  templateUrl: './database-single-select.component.html',
  imports: [CommonModule, SingleSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatabaseSingleSelectComponent {
  @Input() public databases: Connection1cFindInterface[] = [];

  @Input() public selectedDatabase: Connection1cFindInterface;
  @Output() public selectedDatabaseChange = new EventEmitter<Connection1cFindInterface>();

  @Input() public labelInput = false;

  @Input() public styleClass = '';

  @Input() public disabled = false;

  @Input() public class = '';

  @Input() public appendTo: string;

  @Input() public showClear = true;
}
